import type { FC } from "react";
import { Typography } from "@/design-system/Atoms";
import type { OralFeaturedMedData } from "@/design-system/Organisms/OralMedFeaturedMedSection/featuredMed.data";
import { BenefitCard } from "@/design-system/Molecules"; 


interface OralMedFeaturedMedSectionProp {
  heading?: string;
  highlightedHeadingMain?: string;
  highlightedHeadingAccent?: string;
  describe?: string;
  medList: typeof OralFeaturedMedData;
}

const OralMedFeaturedMedSection: FC<OralMedFeaturedMedSectionProp> = ({
  heading,
  highlightedHeadingMain,
  highlightedHeadingAccent,
  describe,
  medList,
}) => { 
  return (
    <section className="relative block w-full h-full bg-[#f6f6f4] border-t-[0] rounded-tl-[60px] rounded-tr-[60px] py-[4.68rem] lg:py-[10rem] bg-cover bg-[url('/images/bg-shape-2.svg')]"> 
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-end -mx-[0.75rem] mb-[3.75rem]">
            <div className="max-w-full lg:w-5/12 px-3">
              <Typography variant="categoryText" as="div" className="mb-10">
                {heading}
              </Typography>
              <Typography variant="sectionHeading" as="h2" className="mb-3">
                <>
                  {highlightedHeadingMain}{" "}
                  <span className="text-gray-400">
                    {highlightedHeadingAccent}
                  </span>
                </>
              </Typography>
            </div>
            <div className="max-w-full px-3 lg:ml-[16.666667%] lg:w-5/12">
              <Typography
                variant="sectionDescriptionLarge"
                as="p"
                className="mb-4"
              >
                {describe}
              </Typography>
            </div>
          </div>
          <div className="flex flex-wrap">
            {medList.map((item, index) => (
              <div
                className="w-full px-[0.75rem] mt-[1.5rem] lg:w-1/3"
                key={index}
              >
                <BenefitCard
                  image={item.image}
                  title={item.title}
                  description={item.description}
                  className={item.className}     
                  isOralMed = {true}     
                />
              </div>
            ))}
          </div>
        </div> 
    </section>
  );
};
export default OralMedFeaturedMedSection;
